<script lang="ts" setup>
  import OtpForm from '@/components/authDialog/OtpForm.vue'
  import { useRouter } from 'vue-router'

  definePage({
    meta: {
      layout: 'blank',
      unauthenticated: true,
    },
  })
  const router = useRouter()
</script>

<template>
  <v-container
    class="forgot-password"
    :class="{
      'h-screen': $vuetify.display.smAndDown,
      'bg-surface': $vuetify.display.smAndDown
    }"
  >
    <v-row class="mx-auto" justify="center">
      <v-col
        class="bg-surface pa-0 rounded-lg"
        cols="12"
        md="6"
        xl="4"
        xxl="4"
      >
        <otp-form @on-success="router.push({ name: 'profile-password' })" />
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
.forgot-password {
  padding-top: 80px;
}

.surface-container {
  background: rgb(var(--v-theme-surface));
}

@media (max-width: 600px) {
  .forgot-password {
    padding-top: 40px;
  }
}

.oauth :deep(.v-otp-input__field) {
  max-width: 64px;
}
</style>
